import { useTranslation } from 'react-i18next'

import { Alert, type AlertSeverity } from './alert'
import { Button } from './button'
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from './dialog'
import { showDialog } from './dialog-stack'

type AlertDialogProps = {
    title: string
    message: string
    severity?: AlertSeverity
}

const AlertDialog = ({ close, title, message, severity = 'info' }: AlertDialogProps & { close: () => void }) => {
    const { t } = useTranslation()

    return (
        <Dialog
            open
            onOpenChange={(open, eventDetails) => {
                if (!open && eventDetails.reason === 'close-press') {
                    close()
                }
            }}
        >
            <DialogContent showCloseButton={false}>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription className="sr-only">{message}</DialogDescription>
                </DialogHeader>
                <Alert severity={severity}>{message}</Alert>
                <DialogFooter>
                    <DialogClose render={<Button type="button" autoFocus />}>{t('actions.ok')}</DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export const showAlertDialog = (props: AlertDialogProps) =>
    showDialog<void>(({ close }) => <AlertDialog {...props} close={close} />)
